import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import tuncayLogo from "../assets/logo/tuncay.png";
import {
  IoHomeOutline,
  IoCardOutline,
  IoTimeOutline,
  IoBusOutline,
  IoLogOutOutline,
  IoMenu,
  IoClose,
  IoPersonCircleOutline,
  IoNotificationsOutline,
} from "react-icons/io5";

export default function Header({ isLoginPage }) {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
  };

  const desktopLinkClass = ({ isActive }) =>
    `inline-flex items-center gap-1.5 px-1 pt-1 border-b-2 font-medium text-sm transition-colors ` +
    (isActive
      ? "border-[#1e3a8a] text-[#1e3a8a]"
      : "border-transparent text-[#1e3a8a] hover:opacity-80");

  const mobileLinkClass = ({ isActive }) =>
    `flex items-center gap-3 pl-3 pr-4 py-4 border-l-4 text-lg font-medium transition-colors ` +
    (isActive
      ? "bg-blue-50/50 border-[#1e3a8a] text-[#1e3a8a]"
      : "border-transparent text-[#1e3a8a] hover:bg-gray-50");

  return (
    <nav className="bg-white shadow-md sticky top-0 py-2 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center grow">
            <Link
              to={isLoginPage ? "#" : "/"}
              className={`flex-shrink-0 flex items-center ${isLoginPage ? "cursor-default" : "cursor-pointer"}`}
            >
              <img src={tuncayLogo} alt="Logo" className="h-10 w-auto" />
            </Link>

            {!isLoginPage ? (
              <div className="hidden md:flex md:ml-auto space-x-6 mr-5">
                <NavLink to="/" end className={desktopLinkClass}>
                  <IoHomeOutline className="text-base" />
                  Ana Sayfa
                </NavLink>

                <NavLink to="/installment" className={desktopLinkClass}>
                  <IoCardOutline className="text-base" />
                  Taksitler
                </NavLink>

                <NavLink to="/history" className={desktopLinkClass}>
                  <IoTimeOutline className="text-base" />
                  Geçmiş
                </NavLink>
                <NavLink to="/watch-bus" className={desktopLinkClass}>
                  <IoBusOutline className="text-base" />
                  Otobüs İzle
                </NavLink>
              </div>
            ) : (
              <div className="hidden md:flex md:ml-auto space-x-6">
                <NavLink to="/login" className={desktopLinkClass}>
                  Giriş Yap
                </NavLink>

                <NavLink to="/service-agreement" className={desktopLinkClass}>
                  Hizmet Sözleşmesi
                </NavLink>
              </div>
            )}
          </div>

          {!isLoginPage && (
            <div className="hidden md:flex items-center space-x-5">
              <NavLink
                to="/notification"
                className="text-[#1e3a8a] hover:opacity-80 transition-opacity"
                title="Bildirimler"
              >
                <IoNotificationsOutline className="text-3xl" />
              </NavLink>

              <NavLink
                to="/profile"
                className="text-[#1e3a8a] hover:opacity-80 transition-opacity"
                title="Profilim"
              >
                <IoPersonCircleOutline className="text-3xl" />
              </NavLink>
              <button
                onClick={handleLogout}
                className="flex items-center gap-1.5 text-red-500 font-medium text-sm bg-gray-50 hover:bg-gray-100 border border-gray-200 px-4 py-2 rounded-lg transition-all shadow-sm"
              >
                <IoLogOutOutline className="text-lg" />
                Çıkış
              </button>
            </div>
          )}

          <div className="flex items-center md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-[#1e3a8a] hover:bg-gray-100 focus:outline-none transition-colors h-10 w-10"
              aria-controls="mobile-menu"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Menüyü Aç</span>
              {isOpen ? (
                <IoClose className="block h-6 w-6" />
              ) : (
                <IoMenu className="block h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div
          className="md:hidden absolute top-full left-0 w-full shadow-lg z-50"
          id="mobile-menu"
        >
          <div className="pt-2 pb-3 space-y-1 bg-white border-t border-gray-200">
            {!isLoginPage ? (
              <>
                <NavLink
                  to="/"
                  end
                  onClick={() => setIsOpen(false)}
                  className={mobileLinkClass}
                >
                  <IoHomeOutline className="text-lg" />
                  Ana Sayfa
                </NavLink>

                <NavLink
                  to="/installment"
                  onClick={() => setIsOpen(false)}
                  className={mobileLinkClass}
                >
                  <IoCardOutline className="text-lg" />
                  Taksitler
                </NavLink>

                <NavLink
                  to="/history"
                  onClick={() => setIsOpen(false)}
                  className={mobileLinkClass}
                >
                  <IoTimeOutline className="text-lg" />
                  Geçmiş
                </NavLink>
                <NavLink
                  to="/watch-bus"
                  onClick={() => setIsOpen(false)}
                  className={mobileLinkClass}
                >
                  <IoBusOutline className="text-lg" />
                  Otobüs İzle
                </NavLink>

                <NavLink
                  to="/notification"
                  onClick={() => setIsOpen(false)}
                  className={mobileLinkClass}
                >
                  <IoNotificationsOutline className="text-xl" />
                  Bildirimler
                </NavLink>

                <NavLink
                  to="/profile"
                  onClick={() => setIsOpen(false)}
                  className={mobileLinkClass}
                >
                  <IoPersonCircleOutline className="text-xl" />
                  Profilim
                </NavLink>

                <div className="pt-4 pb-2 border-t border-gray-200 px-4">
                  <button
                    onClick={() => {
                      setIsOpen(false);
                      handleLogout();
                    }}
                    className="flex items-center justify-center gap-2 w-full bg-white text-red-500 border border-gray-200 px-4 py-2 rounded-lg text-sm font-medium transition-colors shadow-sm"
                  >
                    <IoLogOutOutline className="text-lg" />
                    Çıkış Yap
                  </button>
                </div>
              </>
            ) : (
              <>
                <NavLink
                  to="/service-agreement"
                  onClick={() => setIsOpen(false)}
                  className={mobileLinkClass}
                >
                  Hizmet Sözleşmesi
                </NavLink>
                <NavLink
                  to="/cancellation-and-refund"
                  onClick={() => setIsOpen(false)}
                  className={mobileLinkClass}
                >
                  İptal ve İade Koşulları
                </NavLink>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
}
